<div>
	<button *ngFor="let action of actions;" [disabled]="isDisabled(action)" class="btn btn-default text-primary-color-2" (click)="onClick(action)">
		<fa-icon [icon]="icons[action.icon]"></fa-icon>
	</button>
</div>